var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdsCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.16699 6.33073C7.16699 3.7534 9.25633 1.66406 11.8337 1.66406H28.5003C31.0777 1.66406 33.167 3.7534 33.167 6.33073V32.9974C33.167 35.5747 31.0777 37.6641 28.5003 37.6641H11.8337C9.25633 37.6641 7.16699 35.5747 7.16699 32.9974V6.33073ZM11.8337 4.33073C10.7291 4.33073 9.83366 5.22616 9.83366 6.33073V32.9974C9.83366 34.102 10.7291 34.9974 11.8337 34.9974H28.5003C29.6049 34.9974 30.5003 34.102 30.5003 32.9974V6.33073C30.5003 5.22616 29.6049 4.33073 28.5003 4.33073H11.8337Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1163 10.4587L19.1163 19.8163L16.4392 17.1392C16.0339 16.7338 15.3766 16.7338 14.9712 17.1392C14.5659 17.5445 14.5659 18.2018 14.9712 18.6071L19.4199 23.0558C19.8253 23.4612 20.4825 23.4612 20.8879 23.0558L25.3366 18.6071C25.742 18.2018 25.742 17.5445 25.3366 17.1392C24.9312 16.7338 24.274 16.7338 23.8686 17.1392L21.1924 19.8154L21.1924 10.4587C21.1924 9.88538 20.7276 9.42064 20.1544 9.42064C19.5811 9.42064 19.1163 9.88538 19.1163 10.4587Z",
    fill: "#4D4D4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.154 31.6645C21.3825 31.6645 22.3784 30.6686 22.3784 29.4402C22.3784 28.2117 21.3825 27.2158 20.154 27.2158C18.9256 27.2158 17.9297 28.2117 17.9297 29.4402C17.9297 30.6686 18.9256 31.6645 20.154 31.6645Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdsCampaign);
export default __webpack_public_path__ + "static/media/ads-campaign.e4206a761e5f01e1b3383a2badb1e10d.svg";
export { ForwardRef as ReactComponent };